import { render } from "./BaseSidebarViewer.vue?vue&type=template&id=5c733b6e&scoped=true"
import script from "./BaseSidebarViewer.vue?vue&type=script&lang=js"
export * from "./BaseSidebarViewer.vue?vue&type=script&lang=js"

import "./BaseSidebarViewer.vue?vue&type=style&index=0&id=5c733b6e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c733b6e"]])

export default __exports__